import { useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useLanguage } from '@/hooks/useLanguage';
import JsonLd from '@/components/feature/JsonLd';
import { buildWebsiteSchema, buildOrganizationSchema } from '@/data/seo';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import InfoSections from './components/InfoSections';
import ArticlesSection from './components/ArticlesSection';
import FaqSection from './components/FaqSection';
import FinalCta from './components/FinalCta';

export default function Home() {
  const { lang } = useParams();
  useLanguage(lang);

  const currentLang = lang ?? 'en';

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={buildWebsiteSchema(currentLang)} />
      <JsonLd data={buildOrganizationSchema()} />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <InfoSections />
        <ArticlesSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}